import React, { useRef, useState, useEffect } from "react";
import { Eraser, Check } from "lucide-react";

export function SignaturePad({ onAccept }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * ratio;
    canvas.height = rect.height * ratio;
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0F172A";
  }, []);

  const pos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - rect.left, y: t.clientY - rect.top };
  };

  const start = (e) => {
    e.preventDefault();
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };
  const move = (e) => {
    if (!drawing.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = pos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
    setHasInk(true);
  };
  const end = () => { drawing.current = false; };

  const clear = () => {
    const canvas = canvasRef.current;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    setHasInk(false);
  };

  const accept = () => {
    if (!hasInk) return;
    onAccept(canvasRef.current.toDataURL("image/png"));
  };

  return (
    <div>
      <div className="rounded-xl border-2 border-dashed border-slate-300 bg-white p-1">
        <canvas
          data-testid="driver-signature-canvas"
          ref={canvasRef}
          className="sig-canvas w-full"
          style={{ height: 180 }}
          onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={move} onTouchEnd={end}
        />
      </div>
      <div className="mt-3 flex gap-3">
        <button
          data-testid="signature-clear-btn"
          onClick={clear}
          className="flex flex-1 items-center justify-center gap-2 rounded-xl border border-slate-300 py-3 font-semibold text-slate-600 tap-shrink"
        >
          <Eraser size={18} /> Clear
        </button>
        <button
          data-testid="signature-accept-btn"
          onClick={accept}
          disabled={!hasInk}
          className="flex flex-[2] items-center justify-center gap-2 rounded-xl bg-[#0B192C] py-3 font-bold text-white tap-shrink disabled:opacity-40"
        >
          <Check size={18} /> Accept Signature
        </button>
      </div>
    </div>
  );
}
